const firebaseConfig = {
    //Config
    apiKey: "AIzaSyCj5i1ZqD-z-LrS5j1pCbB7wLghYKiGLjU",
    authDomain: "sweet-travel-d2473.firebaseapp.com",
    projectId: "sweet-travel-d2473",
    storageBucket: "sweet-travel-d2473.appspot.com",
    messagingSenderId: "183265282083",
    appId: "1:183265282083:web:4ab11f8744fc18c2bfc996"
};
export default firebaseConfig;